import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {eopCustomEvent} from "../../../../common/utils/events";
import {FILTER_TOGGLE_EVENT} from "../constants";
import {trackingButtonInteract} from "../../../../tracking/trackingAttributes";
import {UnLitElement} from "../../../../common/elements";

@customElement("eop-search-filter-value")
export class EopSearchFilterValue extends UnLitElement {

    @property({type: Boolean, reflect: true})
    private active: boolean = false;

    public constructor(public category: string, private value: string) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <button class="filter-value" @click=${this.toggleFilter} ${trackingButtonInteract(this.value)}>${this.value}</button>
        `;
    }

    public focusableElement(): HTMLElement {
        return this.renderRoot.querySelector<HTMLElement>("button")!;
    }

    private toggleFilter(): void {
        this.active = !this.active;
        this.dispatchEvent(filterToggleEvent(this.category, this.value));
    }
}

export type FilterToggleEvent = CustomEvent<{ category: string; value: string }>;

export function filterToggleEvent(category: string, value: string): FilterToggleEvent {
    return eopCustomEvent(FILTER_TOGGLE_EVENT, {category: category, value: value});
}